var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameMenuBgm = function SvgIconStorygameMenuBgm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 0V11m11 6.5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 0V8m-11 3V6.764a1 1 0 0 1 .737-.965l9-2.455a1 1 0 0 1 1.263.965V8m-11 3 11-3",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
};
export default SvgIconStorygameMenuBgm;